export enum DocumentCompareAction {
    EnterCompareMode = 'ENTER_COMPARE_MODE',
    ExitCompareMode = 'EXIT_COMPARE_MODE',
    SetFirstFile = 'SET_FIRST_FILE',
    SetSecondFile = 'SET_SECOND_FILE',
    ClearFiles = 'CLEAR_FILES',
}

export type FileToCompare = {
    id: string;
    name: string;
    url: string;
    mimeType?: string;
};

export type DocumentCompareState = {
    isInCompareMode: boolean;
    firstFile: FileToCompare | null;
    secondFile: FileToCompare | null;
    structureId: string | null;
};

export type DocumentCompareActionType =
    | {
          type: DocumentCompareAction.EnterCompareMode;
          payload: string; // structureId
      }
    | {
          type: DocumentCompareAction.ExitCompareMode;
      }
    | {
          type: DocumentCompareAction.SetFirstFile;
          payload: FileToCompare | null;
      }
    | {
          type: DocumentCompareAction.SetSecondFile;
          payload: FileToCompare | null;
      }
    | {
          type: DocumentCompareAction.ClearFiles;
      };
